import React from 'react';

import './skeleton.scss';

const Skeleton = () => {
    return (
        <div className="fullslip__skeleton">
            <span></span>
            <span></span>
            <span></span>
        </div>
    );
};

export default Skeleton;
